import {Base} from "@/api/Base"

export class LeaveAdd extends Base {
    path = "leave/add"
}